const API_HOST =  process.env.REACT_APP_API_HOST || "http://localhost:8080";

const API_SECRET_LOCALSTORAGE_KEY = "AI_EYE_API_KEY";
const NOFOLDER_NAME = "non-folder";

export { API_HOST, API_SECRET_LOCALSTORAGE_KEY, NOFOLDER_NAME };
